import React from 'react';
import PropTypes from 'prop-types';
import AIcon from '../atoms/_atoms.icon';
import AButton from '../atoms/_atoms.button';

export default function MDocumentCard({ title, img, href }) {
	const image = img ? <img src={img} alt="" /> : undefined;

	return (
		<a href={`${href}.pdf`} download>
			<article className="m-document-card">
				<figure>
					{image}
					<figcaption>
						<AIcon type="pdf" className="white" />
					</figcaption>
				</figure>
				<div className="card-body">
					<p>{title}</p>
					<AButton value="DOCUMENTS.DOWNLOAD_PDF" />
				</div>
			</article>
		</a>
	);
}

MDocumentCard.propTypes = {
	title: PropTypes.string.isRequired,
	href: PropTypes.string.isRequired,
	img: PropTypes.string,
};

MDocumentCard.defaultProps = {
	img: undefined,
};




// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.document-card.js